module.exports = __webpack_public_path__ + "img/br12.61e97a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br12.jpg
// module id = J3Up
// module chunks = 0